export default [{
    path: '/personalInformation',
    component: () => import('@/views/personalInformation')
}]